import React from 'react';
import { connect } from 'react-redux';

import { useInventories } from './hooks/useInventories';

import Navbar from '../../../Navbar';
import { LoadingIcon } from '../../../Common/Loading_Icon';
import Button from '../../../Common/DesignSystem/Button';

import { OrderStatusTopSection } from './OrderStatusTopSection';
import { SearchBar } from './SearchBar';
import { InventoryList } from './InventoryList';
import { EmptyState } from './EmptyState';

const OrderStatus = (props) => {
  const {
    inventories,
    isLoadingInventoriesList,
    updateInventoryInline,
    searching,
    searchTerm,
    setSearchTerm,
  } = useInventories({ userSession: props.userSession, location: props.location, history: props.history });

	const addVehicle = () => {
		window.location.assign('vehicleoverview/order/new');
	};

	const handleImportFile = () => {
		window.location.assign('vehicleoverview/order/import');
	};

	return (
		<div className="bkg-white-dark listviewnew medialist">
			<Navbar history={props.history} match={props.match} location={props.location} />

			<OrderStatusTopSection addVehicle={addVehicle} />

			<div className="list-container">
				<div className="list-top-section">
					<SearchBar
						searching={searching}
						searchTerm={searchTerm}
						setSearchTerm={setSearchTerm}
					/>

					<Button secondary leading_ic="Import" label="Import File" onClick={handleImportFile} />
				</div>

				{isLoadingInventoriesList ? (
					<div className="vehicles-table-loading">
						<LoadingIcon />
					</div>
				) : !inventories?.length ? (
					<EmptyState searchTerm={searchTerm} />
				) : (
					<InventoryList
						inventories={inventories}
						updateInventoryInline={updateInventoryInline}
						history={props.history}
						{...props}
					/>
				)}
      </div>
		</div>
	)
}

const mapStateToProps = store => ({
	userSession: store.userSession
});

export default connect(mapStateToProps)(OrderStatus);
